import React from 'react'
import ChangelogInstance from '../ChangelogInstance';

const TwoDotSixDotTwo = () => {
  return (
    <ChangelogInstance version="2.6.2" date="2020-07-04">
      <li>
        Fixed a bug that caused float bars and other listings features not to appear when the user had a custom number of listings to show.
      </li>

    </ChangelogInstance>
  );
}

export default TwoDotSixDotTwo;